import get from "lodash/get";
import find from "lodash/find";
import PropTypes from "prop-types";
import React from "react";
import Modal from "../modal-new";
import Select from "../inputs/select";
import submit from "submit-form";
import {
  isCoach,
  isCoachFreeTrial,
  calculateUserFreeTrialDaysLeft,
} from "../../utils/user-helpers";
import copy from "clipboard-copy";
import getAvatarUrl from "../../utils/get-avatar-url";
import { getRoleNameById } from "../../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import { getOrganizationRoles } from "../../utils/organization-roles";
import SaveInputButtons from "../SaveInputButtons";

class ProfileModal extends React.Component {
  static URL_REGEX =
    /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
  constructor(props, context) {
    super(props, context);
    this.user =
      context.locals.admin_profileUser ||
      find(context.locals.admin_allUsers, ["_id", context.locals.query.user]);

    this.state = {
      plan:
        this.user.coachingBilling && this.user.coachingBilling.plan
          ? this.user.coachingBilling.plan.id
          : "",
      permissions: get(this.user, "permissions", []),
      askForCreditCard: this.user.coachingBilling
        ? this.user.coachingBilling.requestPaymentInfoOnNextLogin
        : true,
      referralLink: this.user.referralProgramInfo?.link || "",
      isEditingReferralLink: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.updateVideoUploadPermission =
      this.updateVideoUploadPermission.bind(this);
    this.updateCustomMobileIconPermission =
      this.updateCustomMobileIconPermission.bind(this);
    this.updateCustomAppStoreListingPermission =
      this.updateCustomAppStoreListingPermission.bind(this);
  }

  handlePermissionToggle({ target: { checked, name } }) {
    const permissions = Object.assign([], this.state.permissions);
    if (!checked && permissions.includes(name))
      permissions.splice(permissions.indexOf(name), 1);
    if (checked && !permissions.includes(name)) permissions.push(name);

    this.setState((prevState) =>
      Object.assign({}, { canSave: true, permissions })
    );
  }

  savePermissions(e) {
    let planInfoIndex, plan;
    if (this.state.plan) {
      planInfoIndex = this.props.stripePlans.findIndex((plan) => {
        return plan.id === this.state.plan;
      });
      plan = this.props.stripePlans[planInfoIndex];
    }

    submit("/actions/user/update-permission-plan", {
      method: "POST",
      body: {
        userId: this.user._id,
        permissions: this.state.permissions,
        plan,
        askForCreditCard: this.state.askForCreditCard,
        email: this.user.email,
      },
    });
  }

  handlePlanChange(value) {
    this.setState({ plan: value, canSave: true });
  }

  handleAskForCreditCardToggle(e) {
    this.setState({
      askForCreditCard: e.target.checked,
      canSave: true,
    });
  }

  /**
   * Update the referral link value
   * @param {*} e
   */
  handleReferralLinkChange(e) {
    const value = e.target.value;
    this.setState((prevState) => ({
      ...prevState,
      referralLink: value,
    }));
  }

  /**
   * Reset the referral Link value
   * @param {*} e
   */
  handleResetReferralLink(e) {
    e.preventDefault();
    this.setState((prevState) => ({
      ...prevState,
      referralLink: this.user.referralProgramInfo?.link || "",
      isEditingReferralLink: false,
    }));
  }

  /**
   * Validate if referral link was changed
   * @returns
   */
  referralLinkChanged = () => {
    const currentLink = this.state.referralLink || "";
    const userLink = this.user.referralProgramInfo?.link || "";
    return currentLink !== userLink && ProfileModal.URL_REGEX.test(currentLink);
  };

  /**
   * Function to close forever the container who shows the referral link information
   * @param {*} e
   */
  handleUpdatereferralLink = (e) => {
    const showReferralButton =
      this.user.referralProgramInfo?.showReferralButton ?? "";
    e.preventDefault();
    submit("/actions/user/update-referral-program", {
      method: "POST",
      body: {
        purpose: "update-link",
        userId: this.user._id,
        referralProgramInfo: {
          link: this.state.referralLink,
          showReferralButton,
        },
      },
    });
  };

  handleClick(e, email) {
    e.preventDefault();
    copy(email);
  }

  updateVideoUploadPermission(e) {
    if (
      confirm(
        "Are you sure you want to update the video upload permission for this user?"
      )
    ) {
      submit("/actions/user/update-video-upload-permission", {
        method: "POST",
        body: {
          userId: this.user._id,
          videoUploadForbidden: Number(!this.user.videoUploadForbidden),
        },
      });
    }
  }

  updateCustomMobileIconPermission(e) {
    if (
      confirm(
        "Are you sure you want to update the custom mobile icon permission for this user?"
      )
    ) {
      submit("/actions/user/update-custom-mobile-icon-permission", {
        method: "POST",
        body: {
          userId: this.user._id,
          customMobileIcon: Number(!this.user.customMobileIcon),
        },
      });
    }
  }

  updateCustomAppStoreListingPermission(e) {
    if (
      confirm(
        "Are you sure you want to update the custom AppStore Listing permission for this user?"
      )
    ) {
      submit("/actions/user/update-custom-appstore-listing-permission", {
        method: "POST",
        body: {
          userId: this.user._id,
          appStoreListingEnable: Number(!this.user.appStoreListingEnable),
        },
      });
    }
  }

  render() {
    const { locals } = this.context;
    const { momentTZ } = locals;
    const stripePlans = this.props.stripePlans;
    const user = this.user;
    const askForCreditCard = this.state.askForCreditCard;
    const referralLink = this.state.referralLink;
    const avatarURL = getAvatarUrl(user);

    const isSubscriber = user.subscription;
    const isMember = user.membership;
    const isCoachUser = isCoach(user);
    const isCoachTrial = isCoachFreeTrial(user);
    const isFe = user.pushAccountInfo;
    const isGym = user.pressAccountInfo;
    const coachTrialLeft =
      isCoachUser && isFe && isCoachTrial
        ? calculateUserFreeTrialDaysLeft(user)
        : null;
    const isPullNoVerified =
      (!isCoachUser &&
        !isFe &&
        !isSubscriber &&
        !user.coach &&
        user.coachingInvite) ||
      user.setup !== "finished";
    const showToken = user.setup !== "finished" && user.token;

    const coachData =
      isSubscriber || isMember ? this.context.locals.athlete : null;

    const isOrganizationUser =
      !!user.organizationId && !!user.organizationRoleId;
    const organizationRoles = getOrganizationRoles();
    const organizationRoleName = isOrganizationUser
      ? getRoleNameById(organizationRoles, user.organizationRoleId)
      : "Coach";

    const EmailContainer = ({ email, id = false }) => (
      <div className="email-container">
        <div className={`profile-email ${id ? "id" : ""}`}>{email}</div>
        <img
          alt="copy"
          src="/img/svg/clipboard.svg"
          style={{
            width: "auto",
            height: id ? "20px" : "24px",
            marginLeft: "0.2vw",
            cursor: "pointer",
          }}
          onClick={(evt) => this.handleClick(evt, email)}
        />
      </div>
    );

    return (
      <Modal
        toClear={["user"]}
        width="600px"
        title={"User Details"}
        className={"admin-profile"}
      >
        <div className="body">
          <div className="Profile-Preview">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                <div className="avatar">
                  <img src={avatarURL} />
                </div>

                <div
                  style={{
                    marginLeft: 10,
                    width: "calc(100% - 190px)",
                  }}
                >
                  <div
                    className="name"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <b>{user.name || "No Name"}</b>
                    </div>
                    <EmailContainer email={user.email} />
                  </div>
                  <div
                    style={{
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <b style={{ marginRight: "10px" }}>ID:</b>{" "}
                    <EmailContainer email={user._id} id />
                  </div>
                  {showToken && (
                    <div
                      style={{
                        textAlign: "left",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <b style={{ marginRight: "10px" }}>Token:</b>{" "}
                      <EmailContainer email={user.token} id />
                    </div>
                  )}
                  {user.country && (
                    <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
                      <b>Country:</b> {user.country}
                    </div>
                  )}
                  <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
                    <b>Member since:</b>{" "}
                    {momentTZ(user.registered).format("MMMM, YYYY")}
                  </div>
                  <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
                    <b>Type:</b>{" "}
                    {isCoachUser
                      ? `${
                          isFe ? `Push${isGym ? " + Press" : ""}` : "Pull"
                        } Coach`
                      : `${
                          isSubscriber
                            ? "Push"
                            : isMember
                            ? `Press (${user.membership.access})`
                            : user.coach
                            ? "Pull"
                            : "Legacy"
                        } Athlete`}
                    {(isSubscriber || isMember) && (
                      <>
                        <div
                          style={{ textAlign: "left", marginBottom: "0.5rem" }}
                        >
                          <b>Coach ID:</b> {coachData._id}
                        </div>
                        <div
                          style={{ textAlign: "left", marginBottom: "0.5rem" }}
                        >
                          <b>Coach Name:</b> {coachData.name}
                        </div>
                        <div
                          style={{ textAlign: "left", marginBottom: "0.5rem" }}
                        >
                          <b>Coach Email:</b>
                          <EmailContainer email={coachData.email} />
                        </div>
                      </>
                    )}
                  </div>
                  {isCoachUser && isCoachTrial && coachTrialLeft > -1 && (
                    <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
                      <b>Free Trial:</b> {coachTrialLeft} days left
                    </div>
                  )}
                  {isFe && (
                    <>
                      <div
                        style={{ textAlign: "left", marginBottom: "0.5rem" }}
                      >
                        <b>Subscribers:</b>{" "}
                        {user.subscribers ? user.subscribers.length : 0}
                      </div>
                      {isGym ? (
                        <div
                          style={{ textAlign: "left", marginBottom: "0.5rem" }}
                        >
                          <b>Members:</b>{" "}
                          {user.members ? user.members.length : 0}
                        </div>
                      ) : null}
                      <div
                        style={{ textAlign: "left", marginBottom: "0.5rem" }}
                      >
                        <b>Stripe ID:</b>{" "}
                        {user.pushAccountInfo.connectedAccountId}
                      </div>
                      <div
                        className="click-admin-toggle"
                        onClick={this.updateVideoUploadPermission}
                      >
                        <b>Video upload forbidden:</b>{" "}
                        {user.videoUploadForbidden ? "on" : "off"}
                      </div>
                    </>
                  )}

                  {(isFe || isCoachUser) && (
                    <div
                      className="click-admin-toggle"
                      onClick={this.updateCustomMobileIconPermission}
                    >
                      <b>Custom mobile icon:</b>{" "}
                      {user.customMobileIcon ? "on" : "off"}
                    </div>
                  )}

                  {(isFe || isCoachUser) && (
                    <div
                      className="click-admin-toggle"
                      onClick={this.updateCustomAppStoreListingPermission}
                    >
                      <b>Enable AppStore Listing:</b>{" "}
                      {user.appStoreListingEnable ? "enabled" : "disabled"}
                    </div>
                  )}

                  {!isCoachUser &&
                    !isFe &&
                    !isSubscriber &&
                    !isMember &&
                    user.coach && (
                      <>
                        <div
                          style={{ textAlign: "left", marginBottom: "0.5rem" }}
                        >
                          <b>Coach:</b> {user.coach.name}
                        </div>
                        <div
                          style={{ textAlign: "left", marginBottom: "0.5rem" }}
                        >
                          <b>Coach Email:</b>{" "}
                          <EmailContainer email={user.coach.email} />
                        </div>
                      </>
                    )}
                  {isPullNoVerified && (
                    <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
                      <b>Invited Athlete not verified yet.</b>
                    </div>
                  )}
                  <div style={{ textAlign: "left", marginBottom: "0.5rem" }}>
                    <b>Organization:</b> {isOrganizationUser ? "Yes" : "No"}
                  </div>
                  {isOrganizationUser && (
                    <>
                      <div
                        style={{ textAlign: "left", marginBottom: "0.5rem" }}
                      >
                        <b>Organization ID:</b> {user.organizationId}
                      </div>
                      <div
                        style={{ textAlign: "left", marginBottom: "0.5rem" }}
                      >
                        <b>Role:</b> {organizationRoleName}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {this.context.locals.stripeRecentEvents.length ? (
                <div>
                  <table className="recent-activity">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.context.locals.stripeRecentEvents.map(
                        ({ type, description, created }) => (
                          <tr key={`${type}-${description}-${created}`}>
                            <td>{type}</td>
                            <td>{description}</td>
                            <td>{created}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>

            <div className="roles">
              <div className="col">
                <label className="checkbox-input">
                  <input
                    type="checkbox"
                    name="admin"
                    onClick={(e) => this.handlePermissionToggle(e)}
                    defaultChecked={
                      user.admin ||
                      (user.permissions && user.permissions.includes("admin"))
                    }
                  />

                  <span className="text">Admin</span>
                </label>
                <label className="checkbox-input">
                  <input
                    type="checkbox"
                    name="coach"
                    onClick={(e) => this.handlePermissionToggle(e)}
                    defaultChecked={
                      user.permissions && user.permissions.includes("coach")
                    }
                  />

                  <span className="text">Coaching portal coach</span>
                </label>
              </div>

              <div className="col">
                <label className="checkbox-input">
                  <input
                    type="checkbox"
                    name="ambassador"
                    onClick={(e) => this.handlePermissionToggle(e)}
                    defaultChecked={
                      user.ambassador ||
                      (user.permissions &&
                        user.permissions.includes("ambassador"))
                    }
                  />

                  <span className="text">Ambassador</span>
                </label>
                <label className="checkbox-input">
                  <input
                    type="checkbox"
                    name="coachCanSubmit"
                    onClick={(e) => this.handlePermissionToggle(e)}
                    defaultChecked={
                      user.permissions &&
                      user.permissions.includes("coachCanSubmit")
                    }
                  />

                  <span className="text">Premium coach</span>
                </label>
              </div>
            </div>
            {this.state.permissions &&
              this.state.permissions.includes("coach") && (
                <div className="referral-link-container">
                  <label htmlFor="referral-link">Referral Link</label>
                  <input
                    name="referral-link"
                    className="text-input !h-10"
                    placeholder="Referral link"
                    value={referralLink}
                    onChange={(e) => this.handleReferralLinkChange(e)}
                    onFocus={() =>
                      this.setState((prevState) => ({
                        ...prevState,
                        isEditingReferralLink: true,
                      }))
                    }
                  />
                  <SaveInputButtons
                    enabled={this.state.isEditingReferralLink}
                    handleSave={(e) => {
                      this.handleUpdatereferralLink(e);
                    }}
                    handleDismiss={(e) => this.handleResetReferralLink(e)}
                    saveDisabled={!this.referralLinkChanged()}
                  />
                </div>
              )}
            {this.state.permissions &&
              this.state.permissions.includes("coach") && (
                <div className="plan-select mt-4">
                  <Select
                    name="plan"
                    className="select-input"
                    title="Select plan"
                    value={this.state.plan}
                    onChange={(e) => this.handlePlanChange(e)}
                    options={stripePlans.map((plan) => {
                      return {
                        value: plan.id,
                        text: plan.nickname,
                      };
                    })}
                  ></Select>
                  <label className="checkbox-input">
                    <input
                      type="checkbox"
                      name="askForCreditCard"
                      onChange={(e) => this.handleAskForCreditCardToggle(e)}
                      defaultChecked={askForCreditCard}
                    />

                    <span className="text">
                      Ask for credit card on next login
                    </span>
                  </label>
                </div>
              )}
          </div>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            Cancel
          </a>
          <button
            onClick={(e) => this.savePermissions(e)}
            type="submit"
            data-button-type="primary"
            disabled={this.state.canSave ? undefined : true}
          >
            Save
          </button>
        </footer>
      </Modal>
    );
  }
}

ProfileModal.contextTypes = { locals: PropTypes.object };

export default ProfileModal;
